module.exports = __webpack_public_path__ + "static/media/sobre-gelatina.56ae49be.png";